// extracted by mini-css-extract-plugin
module.exports = {"section--description":"section--description__2b70q"};